(function () {
  'use strict';

  var FORM_NAME = 'zsWebToCase_1380125000000407066';
  var wizard = document.getElementById('zohoContactWizard');
  if (!wizard) return;

  var state = {
    step: 1,
    category: '',
    firstName: '',
    lastName: '',
    email: '',
    subject: '',
    message: ''
  };

  var panels = wizard.querySelectorAll('[data-step-panel]');
  var indicators = wizard.querySelectorAll('[data-step-indicator]');
  var pills = wizard.querySelectorAll('.zoho-wizard__pill');
  var modal = document.querySelector('[data-message-modal]');
  var subscriptionModal = document.querySelector('[data-subscription-modal]');
  var loopPortalUrl = wizard.getAttribute('data-loop-portal-url') || '/a/loop_subscriptions/get-subscription-link';
  var fileList = wizard.querySelector('[data-file-list]');
  var captchaMount = wizard.querySelector('[data-captcha-mount]');
  var step3Intro = wizard.querySelector('[data-step3-intro]');
  var step3Saved = wizard.querySelector('[data-step3-saved]');

  if (modal && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  if (subscriptionModal && subscriptionModal.parentElement !== document.body) {
    document.body.appendChild(subscriptionModal);
  }

  function setVisible(el, visible) {
    if (!el) return;
    if (visible) {
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', '');
    }
  }

  function hasSavedMessage() {
    return Boolean(state.subject);
  }

  function updateStep3Headings() {
    var hasMessage = hasSavedMessage();
    setVisible(step3Intro, !hasMessage);
    setVisible(step3Saved, hasMessage);
  }

  function updateMessagePreview() {
    var preview = wizard.querySelector('[data-message-preview]');
    var title = wizard.querySelector('[data-message-preview-title]');
    var body = wizard.querySelector('[data-message-preview-body]');
    if (!preview || !title || !body) return;

    if (state.subject || state.message) {
      setVisible(preview, true);
      title.textContent = state.subject;
      body.textContent = state.message || 'No message body provided.';
    } else {
      setVisible(preview, false);
      title.textContent = '';
      body.textContent = '';
    }

    updateStep3Headings();
  }

  function getForm() {
    return document.forms[FORM_NAME];
  }

  function showError(key, message) {
    var el = wizard.querySelector('[data-error="' + key + '"]') || document.querySelector('[data-error="' + key + '"]');
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function clearErrors() {
    wizard.querySelectorAll('.zoho-wizard__error').forEach(function (el) {
      el.hidden = true;
      el.textContent = '';
    });
    if (modal) {
      modal.querySelectorAll('.zoho-wizard__error').forEach(function (el) {
        el.hidden = true;
        el.textContent = '';
      });
    }
  }

  function isValidEmail(value) {
    return /^([\w_][\w\-_.+'&]*)@(?=.{4,256}$)(([\w]+)([\-_]*[\w])*[.])+[a-zA-Z]{2,22}$/.test(value);
  }

  function setStep(step) {
    state.step = step;
    panels.forEach(function (panel) {
      var panelStep = Number(panel.getAttribute('data-step-panel'));
      var active = panelStep === step;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });

    indicators.forEach(function (indicator) {
      var indicatorStep = Number(indicator.getAttribute('data-step-indicator'));
      indicator.classList.toggle('is-active', indicatorStep === step);
      indicator.classList.toggle('is-complete', indicatorStep < step);
    });

    if (step === 4) {
      populateReview();
      mountCaptcha();
    }

    if (step === 3) {
      updateMessagePreview();
    }
  }

  function syncToZohoForm() {
    var form = getForm();
    if (!form) return;

    if (form.Classification) form.Classification.value = state.category;
    if (form['First Name']) form['First Name'].value = state.firstName;
    if (form['Contact Name']) form['Contact Name'].value = state.lastName;
    if (form.Email) form.Email.value = state.email;
    if (form.Subject) form.Subject.value = state.subject;
    if (form.Description) form.Description.value = state.message;
  }

  function validateStep(step) {
    clearErrors();

    if (step === 1) {
      if (!state.category) {
        showError('category', 'Please select an issue type to continue.');
        return false;
      }
    }

    if (step === 2) {
      state.firstName = document.getElementById('zohoWizardFirstName').value.trim();
      state.lastName = document.getElementById('zohoWizardLastName').value.trim();
      state.email = document.getElementById('zohoWizardEmail').value.trim();

      if (!state.lastName) {
        showError('details', 'Please enter your last name.');
        return false;
      }
      if (!state.email || !isValidEmail(state.email)) {
        showError('details', 'Please enter a valid email address.');
        return false;
      }
    }

    if (step === 3) {
      if (!state.subject) {
        showError('message', 'Please add a message before continuing.');
        return false;
      }
    }

    syncToZohoForm();
    return true;
  }

  function populateReview() {
    var fullName = [state.firstName, state.lastName].filter(Boolean).join(' ');
    var categoryEl = wizard.querySelector('[data-review="category"]');
    var nameEl = wizard.querySelector('[data-review="name"]');
    var emailEl = wizard.querySelector('[data-review="email"]');
    var subjectEl = wizard.querySelector('[data-review="subject"]');
    var messageEl = wizard.querySelector('[data-review="message"]');
    var reviewFiles = wizard.querySelector('[data-review="files"]');

    if (categoryEl) categoryEl.textContent = state.category;
    if (nameEl) nameEl.textContent = fullName || state.lastName;
    if (emailEl) emailEl.textContent = state.email;
    if (subjectEl) subjectEl.textContent = state.subject;
    if (messageEl) messageEl.textContent = state.message || '—';

    if (!reviewFiles) return;
    reviewFiles.innerHTML = '';
    if (fileList) {
      fileList.querySelectorAll('li').forEach(function (item) {
        var clone = item.cloneNode(true);
        reviewFiles.appendChild(clone);
      });
    }
  }

  function getCaptchaInput() {
    if (!captchaMount) return null;
    return captchaMount.querySelector('input[name="zsWebFormCaptchaWord"]');
  }

  function syncCaptchaToForm() {
    var form = getForm();
    var visibleInput = getCaptchaInput();
    if (!form) return null;

    var formCaptcha = form.querySelector('input[name="zsWebFormCaptchaWord"]');
    if (!formCaptcha) {
      formCaptcha = document.createElement('input');
      formCaptcha.type = 'hidden';
      formCaptcha.name = 'zsWebFormCaptchaWord';
      form.appendChild(formCaptcha);
    }

    if (visibleInput && formCaptcha !== visibleInput) {
      formCaptcha.value = visibleInput.value;
    }

    return formCaptcha;
  }

  function bindCaptchaInputSync() {
    var visibleInput = getCaptchaInput();
    if (!visibleInput || visibleInput.dataset.captchaSyncBound === 'true') return;

    visibleInput.dataset.captchaSyncBound = 'true';
    visibleInput.addEventListener('input', syncCaptchaToForm);
    visibleInput.addEventListener('change', syncCaptchaToForm);
  }

  function bindCaptchaRefresh() {
    if (!captchaMount) return;

    var refreshLink = captchaMount.querySelector('#zsCaptcha a');
    if (!refreshLink || refreshLink.dataset.captchaRefreshBound === 'true') return;

    refreshLink.dataset.captchaRefreshBound = 'true';
    refreshLink.setAttribute('href', '#');
    refreshLink.addEventListener('click', function (event) {
      event.preventDefault();
      if (typeof window.zsRegenerateCaptcha === 'function') {
        window.zsRegenerateCaptcha();
      }
      var visibleInput = getCaptchaInput();
      if (visibleInput) visibleInput.value = '';
      syncCaptchaToForm();
    });
  }

  function mountCaptcha() {
    var form = getForm();
    if (!form || !captchaMount) return;

    var loading = form.querySelector('#zsCaptchaLoading');
    var captcha = form.querySelector('#zsCaptcha');
    var captchaInput = form.querySelector('input[name="zsWebFormCaptchaWord"]');

    if (loading && loading.parentElement !== captchaMount) captchaMount.appendChild(loading);
    if (captcha && captcha.parentElement !== captchaMount) captchaMount.appendChild(captcha);
    if (captchaInput && captchaInput.parentElement !== captchaMount) captchaMount.appendChild(captchaInput);

    syncCaptchaToForm();
    bindCaptchaInputSync();
    bindCaptchaRefresh();

    if (typeof window.zsRegenerateCaptcha === 'function') {
      var captchaImage = captchaMount.querySelector('#zsCaptchaUrl');
      if (captchaImage && (!captchaImage.getAttribute('src') || captchaImage.getAttribute('src') === '#')) {
        window.zsRegenerateCaptcha();
      }
    }
  }

  function refreshFileList() {
    if (!fileList) return;
    fileList.innerHTML = '';

    var zohoList = document.getElementById('zsFileBrowseAttachments');
    if (!zohoList) return;

    zohoList.querySelectorAll('.filenamecls').forEach(function (item) {
      var li = document.createElement('li');
      li.textContent = item.textContent.replace(/\s*X\s*$/, '').trim();
      fileList.appendChild(li);
    });
  }

  function openMessageModal() {
    if (!modal) return;
    document.getElementById('zohoWizardSubject').value = state.subject;
    document.getElementById('zohoWizardMessage').value = state.message;
    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMessageModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.classList.remove('is-open');
    if (!subscriptionModal || !subscriptionModal.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }
    showError('modal', '');
  }

  function openSubscriptionModal() {
    if (!subscriptionModal) return;
    subscriptionModal.hidden = false;
    subscriptionModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var continueBtn = subscriptionModal.querySelector('[data-action="subscription-continue"]');
    if (continueBtn) continueBtn.focus();
  }

  function closeSubscriptionModal() {
    if (!subscriptionModal) return;
    subscriptionModal.hidden = true;
    subscriptionModal.classList.remove('is-open');
    if (!modal || !modal.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }
  }

  function goToLoopPortal() {
    window.location.assign(loopPortalUrl);
  }

  function saveMessageModal() {
    var subjectInput = document.getElementById('zohoWizardSubject');
    var messageInput = document.getElementById('zohoWizardMessage');
    if (!subjectInput || !messageInput) return;

    state.subject = subjectInput.value.trim();
    state.message = messageInput.value.trim();

    if (!state.subject) {
      showError('modal', 'Please enter a subject.');
      return;
    }

    syncToZohoForm();
    updateMessagePreview();
    closeMessageModal();
  }

  function triggerAttachmentPicker() {
    for (var i = 1; i <= 5; i += 1) {
      var input = document.getElementById('zsattachment_' + i);
      if (!input) continue;
      if (input.offsetParent !== null || i === 1) {
        input.click();
        break;
      }
    }
  }

  function submitForm() {
    syncToZohoForm();
    syncCaptchaToForm();
    var form = getForm();
    if (!form) return;

    var captchaInput = getCaptchaInput();
    var captchaValue = captchaInput ? captchaInput.value.trim() : '';
    if (!captchaValue) {
      showError('submit', 'Please enter the captcha code.');
      if (captchaInput) captchaInput.focus();
      return;
    }

    syncCaptchaToForm();
    showError('submit', '');
    var submitButton = document.getElementById('zsSubmitButton_1380125000000407066');
    if (submitButton) submitButton.click();
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) {
        p.classList.remove('is-selected');
      });
      pill.classList.add('is-selected');
      state.category = pill.getAttribute('data-category') || '';
      showError('category', '');
    });
  });

  wizard.addEventListener('click', function (event) {
    var target = event.target.closest('[data-action]');
    if (!target) return;

    event.preventDefault();

    var action = target.getAttribute('data-action');

    if (action === 'next') {
      if (!validateStep(state.step)) return;
      if (state.step === 1 && state.category === 'Subscription') {
        openSubscriptionModal();
        return;
      }
      setStep(state.step + 1);
      return;
    }

    if (action === 'back') {
      setStep(Math.max(1, state.step - 1));
      return;
    }

    if (action === 'goto') {
      setStep(Number(target.getAttribute('data-goto-step')) || 1);
      return;
    }

    if (action === 'open-message' || action === 'edit-message') {
      openMessageModal();
      return;
    }

    if (action === 'attach-file') {
      triggerAttachmentPicker();
      return;
    }

    if (action === 'submit') {
      submitForm();
    }
  });

  if (modal) {
    modal.hidden = true;
    modal.classList.remove('is-open');

    modal.addEventListener('click', function (event) {
      var target = event.target.closest('[data-action]');
      if (!target) return;

      event.preventDefault();

      var action = target.getAttribute('data-action');
      if (action === 'close-message') closeMessageModal();
      if (action === 'save-message') saveMessageModal();
    });
  }

  if (subscriptionModal) {
    subscriptionModal.hidden = true;
    subscriptionModal.classList.remove('is-open');

    subscriptionModal.addEventListener('click', function (event) {
      var target = event.target.closest('[data-action]');
      if (!target) return;

      event.preventDefault();

      var action = target.getAttribute('data-action');
      if (action === 'subscription-not-now') closeSubscriptionModal();
      if (action === 'subscription-continue') goToLoopPortal();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (subscriptionModal && subscriptionModal.classList.contains('is-open')) {
      closeSubscriptionModal();
      return;
    }
    if (modal && modal.classList.contains('is-open')) {
      closeMessageModal();
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.id && event.target.id.indexOf('zsattachment_') === 0) {
      window.setTimeout(refreshFileList, 100);
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('zsfilebrowseAttachment')) {
      window.setTimeout(refreshFileList, 100);
    }
  });

  document.body.classList.add('zoho-contact-wizard-active');
})();
